<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-12 pb-2">
        {{$t('import_export_contact')}}
      </div>
    </div>
    <ul class="nav nav-tabs  nav-tabs-highlight skin light-bg mb-0" id="procedureTabs">
      <li class="nav-item" style="border-left-width:0px !important">
        <a href="#contact-export" onclick="hideUnHideElement('#contact-export','#contact-import')" class="nav-link active show" data-toggle="tab">
          <i class="icon-file-download"></i>{{ $t('export_contact')}}
        </a>
      </li>
      <li class="nav-item">
        <a href="#contact-import" onclick="hideUnHideElement('#contact-import','#contact-export')" class="nav-link" data-toggle="tab">
          <i class="icon-file-upload"></i> {{$t('import_contact')}}
        </a>
      </li>
    </ul>
    <div class="container-fluid">
      <div class="row">
        <div class="col p-2">
          <div class="tab-content border-top-0 rounded-top-0 mb-0">
            <div id="contact-export" class="tab-pane1 show active">
              <div class="row px-0 mt-1">
                <div class="text-right col-sm-12 mt-1 px-0">
                  <button v-on:click="exportContact" class="btn skin primary-button mt-1">{{$t('export_procedure')}}</button>
                </div>
              </div>
            </div>
            <div id="contact-import" class="tab-pane1 fade" style="display:none;">
              <div class="row  px-0 mt-3">
                <div class="col-6">
                  <input type="file" @change="selectFile" class="h-auto" accept=".xlsx,.xls" />
                </div>
                <div class="col-6 text-right px-0" style="text-align:right">
                  <button class="btn skin primary-button" v-on:click="importFile">{{$t('import_procedure')}}</button>
                </div>
                <div class="col-12">
                  <div v-if="msg != null && msg != ''" class="col-12 alert shadow-0 alert-success border-0 upload-error-message mt-3" role="alert">
                    <ul>
                      <li class="col-12">
                        {{ msg }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var procedureId = -1;
  var msg = "";
  export default {
    name: "contact-export-import",
    components: {

    },
    props: {
    },
    data() {
      return {
        procedureId: -1,
        selectedFiles: undefined,
        msg
      };
    },
    computed: {

    },

    methods: {
      async importFile() {
        if (this.selectedFiles == null || this.selectedFiles.length == 0)
          return;
        try {
          // try to log $refs object for deep understanding
          let fileToUpload = this.selectedFiles[0];
          let formData = new FormData();
          formData.append('fileToUpload', fileToUpload);
          var apiresponse = await this.$http.post(
            '/api/Contacts/v1/Upload',
            formData
          ).then(response => {
            this.msg = this.$t('import_contacts_success');
            this.$forceUpdate();
          });

        } catch (err) {
          //alert(err);
        }
        //e.preventDefault();
      },
      selectFile(event) {
        this.msg = '';
        this.selectedFiles = event.target.files;
      },
      onChangeProc(id) {
        this.procedureId = id;
      },
      async exportContact() {
        try {
          var url = apiUrl + '/api/Contacts/v1/Download' + '?siteId=' + this.$store.getSiteId();
          window.location = url;
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
    },
    mounted() {
      _componentValidation('#procdureExportForm');
      //this.activateTab("procedure-detail-editPanel");

    },
    created: function () {

    },
    watch: {
    },
  };

</script>

<style scoped>

  .nav-item {
  }

  .nav-link.active::before {
  }

  .nav-link {
    padding-left: 15px;
    padding-right: 15px;
  }

    .nav-link.active {
      /*background-color: white !important;*/
    }

  .tab-content {
    /*background-color: white !important;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/contact/contact-export-import.vue